<script setup lang="ts">
/** Dialogue générique avec note — utilisé pour clôturer / annuler une demande. */
import { ref, watch } from 'vue'

const props = defineProps<{
  open: boolean
  title: string
  label: string
  confirmLabel: string
  /** `error` → bouton de confirmation destructif. */
  variant?: 'primary' | 'error'
  required?: boolean
  loading?: boolean
}>()
const emit = defineEmits<{ close: []; confirmed: [note: string] }>()

const dialog = ref<HTMLDialogElement | null>(null)
const note = ref('')

watch(
  () => props.open,
  (open) => {
    if (open) {
      note.value = ''
      if (!dialog.value?.open) dialog.value?.showModal()
    } else {
      dialog.value?.close()
    }
  },
)

function confirm() {
  if (props.required && !note.value.trim()) return
  emit('confirmed', note.value.trim())
}
</script>

<template>
  <dialog ref="dialog" class="modal" @close="emit('close')">
    <div class="modal-box">
      <h3 class="text-lg font-semibold">{{ title }}</h3>
      <div class="mt-4">
        <label for="note-dialog" class="mb-1 block text-sm font-medium text-base-content">
          {{ label }} <span v-if="required" class="text-error" aria-hidden="true">*</span>
        </label>
        <textarea
          id="note-dialog"
          v-model="note"
          rows="3"
          class="textarea textarea-bordered w-full text-base"
        ></textarea>
      </div>
      <div class="modal-action">
        <button type="button" class="btn btn-ghost" :disabled="loading" @click="emit('close')">Annuler</button>
        <button
          type="button"
          class="btn"
          :class="variant === 'error' ? 'btn-error' : 'btn-primary'"
          :disabled="loading || (required && !note.trim())"
          :aria-busy="loading"
          @click="confirm"
        >
          <span v-if="loading" class="loading loading-spinner loading-xs" aria-hidden="true"></span>
          {{ confirmLabel }}
        </button>
      </div>
    </div>
    <form method="dialog" class="modal-backdrop">
      <button @click="emit('close')">Fermer</button>
    </form>
  </dialog>
</template>
